import { useTranslation } from 'react-i18next';

import { CrmPreviewModal } from 'src/features/appBuilder/crm-preview-modal';

interface PortalInterceptModalProps {
  isOpen: boolean;
  /** Dismiss without entering the portal (close button, backdrop, escape). */
  onClose: () => void;
  /** Primary CTA — take the user into the CRM guided flow. */
  onGoToCrm: () => void;
  /** Secondary CTA — open the sign-in page anyway (the original shortcut). */
  onOpenSignInPage: () => void;
}

/**
 * Studio FTUX modal shown when a user clicks the sidebar "Client experience"
 * shortcut before completing the Explore step. It recommends visiting the CRM
 * first (to activate the test client and sign in as them) rather than dropping
 * into the logged-out sign-in page cold, while still letting them continue.
 * Reuses the shared CRM-preview shell.
 */
export const PortalInterceptModal = ({
  isOpen,
  onClose,
  onGoToCrm,
  onOpenSignInPage,
}: PortalInterceptModalProps) => {
  const { t } = useTranslation();

  return (
    <CrmPreviewModal
      isOpen={isOpen}
      onClose={onClose}
      title={t(($) => $.crm.portal_intercept.title)}
      description={t(($) => $.crm.portal_intercept.description)}
      dismissLabel={t(($) => $.crm.portal_intercept.dismiss)}
      previewAlt={t(($) => $.crm.portal_intercept.preview_alt)}
      primaryLabel={t(($) => $.crm.portal_intercept.go_to_crm)}
      onPrimary={onGoToCrm}
      secondaryLabel={t(($) => $.crm.portal_intercept.open_sign_in_page)}
      onSecondary={onOpenSignInPage}
    />
  );
};
